import { Box, Container, Hidden, makeStyles } from "@material-ui/core";
import { BrowserRouter as Router } from "react-router-dom";
import Footer from "../Footer";
import Header from "../Header";
import MobileMenu from "../MobileMenu";
import Sidebar from "../Sidebar";
import ScrollToTop from "../utils/ScrollToTop";

const useStyle = makeStyles((theme) => ({
  root: {
    background: theme.palette.background.primary,
  },
  container: {
    marginLeft: 220,
    transition: "margin 0.5s linear",
    [theme.breakpoints.only("sm")]: {
      marginLeft: 80,
    },
    [theme.breakpoints.only("xs")]: {
      marginLeft: 0,
    },
  },
  mainContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    minHeight: "calc(100vh - 70px)",
    paddingTop: "4rem",
  },
}));

export default function ComponentWrapper({ children }) {
  const cls = useStyle();

  return (
    <Router basename="/scoring">
      <Box position="relative" className={cls.root}>
        <Header />
        <Box className={cls.container}>
          <Hidden only={"xs"}>
            <Sidebar />
          </Hidden>
          <Container className={cls.mainContainer}>
            <Box>{children}</Box>
            <Footer />
          </Container>
          <Hidden smUp>
            <MobileMenu />
          </Hidden>
        </Box>
        <ScrollToTop />
      </Box>
    </Router>
  );
}
